import React from 'react'
import PropTypes from 'prop-types'
import styles from './create_card.less'
import cssModules from 'react-css-modules'
import { Link } from 'react-router'
import { Icon, Tile, Text } from '@paypalcorp/pp-react'
import { trackClick } from 'lib/fpti_analytics'

class CreateCard extends React.Component {
  static propTypes = {
    to: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    iconName: PropTypes.string,
    event_name: PropTypes.string,
    flow: PropTypes.string,
    data_nemo: PropTypes.string,
  }

  render() {
    return (
      <Link
        to={this.props.to}
        styleName="cart-link"
        data-nemo={this.props.data_nemo}
        onClick={() =>
          trackClick({
            clickName: this.props.event_name,
            data: {
              event_name: this.props.event_name,
              flow: this.props.flow,
            },
          })
        }
      >
        <Tile cardRadius="lg" styleName="content-wrapper">
          <Icon name={this.props.iconName} size="lg" styleName="content-icon" />
          <Tile.Content>
            <Text styleName="cart-title">{this.props.title}</Text>
            <Text styleName="cart-subtitle">{this.props.subtitle}</Text>
          </Tile.Content>
        </Tile>
      </Link>
    )
  }
}

export default cssModules(CreateCard, styles)
